import { gql } from '@apollo/client';

export const FILTERED_SPS_FOR_SELECT_INPUT = gql`
  query FilteredServiceProvidersForSelectInput($input: FilterArgs!) {
    serviceProviders: filteredServiceProviders(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
